import { useQuery } from "@tanstack/react-query"
import { employeesQuery } from "../lib/employeesQuery"

export function useEmployeesQuery(...args: Parameters<typeof employeesQuery>) {
  return useQuery(employeesQuery(...args))
}
